const lastLogSignatureByPage = new Map();

/**
 * Logs every individual answer behind an Items Overview page in a copyable format.
 */
export const logItemsOverviewData = ({ pageName, items, allResults, startIndex = 0 }) => {
  if (!items?.length || !allResults?.length) return;

  const rows = items.flatMap((item, index) => {
    const resultIndex = startIndex + index;
    const individualScores = allResults[resultIndex]?.individualScores || [];

    return individualScores
      .filter(({ score }) => Number(score) > 0)
      .map(({ name, hash, designation, score }) => ({
        "#": item.no ?? resultIndex + 1,
        Quadrant: item.quadrant,
        Question: item.question,
        Person: name || hash || "Unknown",
        Relationship: designation || "Unknown",
        Score: Number(score),
      }));
  });

  const signature = JSON.stringify(rows);
  if (lastLogSignatureByPage.get(pageName) === signature) return;

  lastLogSignatureByPage.set(pageName, signature);
  console.groupCollapsed(`[Items Overview – individual answers] ${pageName}`);
  console.table(rows);
  console.log("Copyable individual-answer data:", rows);
  console.groupEnd();
};
